/*  Shared  */
import ObjectPicker from 'application/Shared/Components/Pickers/Components/ObjectPicker';
import { Response } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withRouter } from 'router/withRouter';

class PermissionPicker extends Component {
    constructor(props) {
        super(props);

        const { permissionsData } = props;

        const hasPermissionsData = permissionsData?.length > 0;

        this.state = {
            loaded: hasPermissionsData,
            objectNameField: 'name',
            objectPayload: hasPermissionsData ? permissionsData : []
        };

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { match, permissionsData } = this.props;

        // If we already have permissions data, use that instead of fetching from the API.
        if (permissionsData?.length) {
            return;
        }

        const { clientId } = match.params;

        const params = { size: -1 };
        if (clientId) {
            params.platformTenantId = clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/permission', {
                cancelToken: this.requests.token(),
                params
            });
            if (!Response.hasData(response)) {
                debug.e('No Permission Found', response);
                this.setState({ loaded: true });
                return;
            }

            const objectPayload = Response.getData(response);
            this.setState({ loaded: true, objectPayload });
        } catch (e) {
            /* */
        }
    };

    unload = () => {
        this.requests.cancel();
    };

    render() {
        const { loaded, objectPayload, objectNameField } = this.state;
        const { useIceberg } = this.props;
        if (!loaded) {
            return null;
        }

        // TODO: Update when migrating over to new iceberg components
        // Set default new user permission to first option
        const objectPayloadUpdated = useIceberg
            ? objectPayload
                  .map((permissionPayload) => ({
                      ...permissionPayload,
                      label: permissionPayload.name,
                      value: permissionPayload.id
                  }))
                  .sort((a, b) => b.defaultNewUser - a.defaultNewUser)
            : objectPayload;

        return (
            <ObjectPicker
                {...this.props}
                objectPayload={objectPayloadUpdated}
                objectNameField={objectNameField}
            />
        );
    }
}

export default withRouter(PermissionPicker);
